export const membershipTiersBenefitsMock = {
  isAuthorMode: true,
  model: {
    showBenefitsChart: true,
    disclaimerText: '',
    eliteBenefitsByTierHeader: 'Elite Benefits by Tier',
    memberTiersHeader: 'Membership Tiers',
    memberLevel: 'Member',
    desktopColumns: '5',
    tabletColumns: '4',
    mobileColumns: '1',
    eliteLabel: 'Elite',
    tabLabel: 'tab',
    memberLevelDetails: [
      {
        name: 'Member',
        tierName: 'Basic',
        tierKey: 'R',
        nightsPerYear: '0-9 nights per year',
        subHeader: 'The possibilities (and points) are endless',
        tableNightsPerYear: '',
        tierHeaderBackground: '',
        tierIconColor: '',
      },
      {
        name: 'Silver Elite',
        tierName: 'Silver',
        tierKey: 'S',
        nightsPerYear: '10-24 nights per year',
        subHeader: 'A little recognition goes a long way',
        tableNightsPerYear: '',
        tierHeaderBackground: 'silverGradient',
        tierIconColor: 'silverSolid',
      },
      {
        name: 'Gold Elite',
        tierName: 'Gold',
        tierKey: 'G',
        nightsPerYear: '25-49 nights per year',
        subHeader: 'Extra perks every time you check in',
        tableNightsPerYear: '',
        tierHeaderBackground: 'goldGradient',
        tierIconColor: 'goldSolid',
      },
      {
        name: 'Platinum Elite',
        tierName: 'Platinum',
        tierKey: 'P',
        nightsPerYear: '50-74 nights per year',
        subHeader: 'More room to spread out',
        tableNightsPerYear: '',
        tierHeaderBackground: 'platinumGradient',
        tierIconColor: 'platinumSolid',
      },
      {
        name: 'Titanium Elite',
        tierName: 'Titanium',
        tierKey: 'PPC',
        nightsPerYear: '75-99 nights per year',
        subHeader: 'Elite recognition at more doors',
        tableNightsPerYear: '',
        tierHeaderBackground: 'titaniumGradient',
        tierIconColor: 'titaniumSolid',
      },
      {
        name: 'Ambassador Elite',
        tierName: 'Ambassador',
        tierKey: 'PFS',
        nightsPerYear: '100+ nights per year',
        subHeader: 'Your Ambassador, your itinerary',
        tableNightsPerYear: '',
        tierHeaderBackground: 'ambassadorGradient',
        tierIconColor: 'ambassadorSolid',
      },
    ],
    trackingProperties: [
      {
        keyValue: 'ambassador_plus_one',
        clickTrack: true,
        trackingDescription: 'More Details',
        impressionTrack: false,
        trackingContentPosition: 'Ambassador Plus One',
        impressionCount: false,
        linkType: 'external',
      },
      {
        keyValue: 'hertz_gold_plus_rewards',
        clickTrack: true,
        trackingDescription: 'Link Your Account',
        impressionTrack: false,
        trackingContentPosition: 'Hertz Gold Plus Rewards',
        impressionCount: false,
        linkType: 'external',
      },
      {
        keyValue: 'sixt_status_match',
        clickTrack: true,
        trackingDescription: 'Link Your Account',
        impressionTrack: false,
        trackingContentPosition: 'Sixt Status Match',
        impressionCount: false,
        linkType: 'external',
      },
      {
        keyValue: 'welcome_gift',
        clickTrack: true,
        trackingDescription: 'More Details',
        impressionTrack: false,
        trackingContentPosition: 'Welcome Gift',
        impressionCount: false,
        linkType: 'external',
      },
      {
        keyValue: 'lounge_access',
        clickTrack: true,
        trackingDescription: 'More Details',
        impressionTrack: false,
        trackingContentPosition: 'Lounge Access',
        impressionCount: false,
        linkType: 'external',
      },
      {
        keyValue: 'annual_choice_benefit',
        clickTrack: true,
        trackingDescription: 'More Details',
        impressionTrack: false,
        trackingContentPosition: 'Annual Choice Benefit',
        impressionCount: false,
        linkType: 'external',
      },
      {
        keyValue: '48_hour_guarantee',
        clickTrack: true,
        trackingDescription: 'More Details',
        impressionTrack: false,
        trackingContentPosition: '48 Hour Guarantee',
        impressionCount: false,
        linkType: 'external',
      },
      {
        keyValue: 'emirates_skywards',
        clickTrack: true,
        trackingDescription: 'Link Your Account',
        impressionTrack: false,
        trackingContentPosition: 'Emirates Skywards',
        impressionCount: false,
        linkType: 'external',
      },
      {
        keyValue: 'united_mileage_plus',
        clickTrack: true,
        trackingDescription: 'Link Your Account',
        impressionTrack: false,
        trackingContentPosition: 'United Mileage Plus',
        impressionCount: false,
        linkType: 'external',
      },
      {
        keyValue: 'instant_redemption',
        clickTrack: true,
        trackingDescription: 'More Details',
        impressionTrack: false,
        trackingContentPosition: 'Instant Redemption',
        impressionCount: false,
        linkType: 'external',
      },
      {
        keyValue: 'cash_plus_points',
        clickTrack: true,
        trackingDescription: 'More Details',
        impressionTrack: false,
        trackingContentPosition: 'Cash + Points',
        impressionCount: false,
        linkType: 'external',
      },
    ],
  },
};

export const membershipTiersBenefitsMockData = [
  {
    tier: 'Ambassador',
    tierTag: ['mcom-common-spa:mobile/member-tiers/ambassador'],
    benefits: [
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'ambassador_service',
        icon: 'ambassador',
        title: 'Ambassador Service',
        fullText: 'Dedicated Personal Ambassador to assist you with all of your travel needs.',
        ctaCopy: 'Learn more',
        ctaKey: 'Learn more',
        ctaLink: '/loyalty/ambassador-service.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 1,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'your_24',
        icon: 'your_24',
        title: 'Your24™',
        fullText:
          'Choose your check-in time and keep your room until the same time on the day of departure. Request via Ambassador Service 2 days prior to arrival.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: 'Based on availability. Property and brand exceptions apply.',
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 2,
      },
      {
        _variation: 'master',
        activeTiers: ['Titanium', 'Ambassador'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'bonus_points',
        icon: 'more_points_on_stays',
        title: '75% Bonus Points',
        fullText: 'Earn bonus points on eligible hotel purchases.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'To be eligible, you must provide your member number when making a reservation. Compensation varies by hotel brand.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: '75% Bonus Points',
        benefitCode: null,
        modalTable: [
          {
            title: '10% Bonus Points',
            subtitle: '10% Bonus Points',
            activeTiers: ['Silver'],
          },
          {
            title: '25% Bonus Points',
            subtitle: '25% Bonus Points',
            activeTiers: ['Gold'],
          },
          {
            title: '50% Bonus Points',
            subtitle: '50% Bonus Points',
            activeTiers: ['Platinum'],
          },
        ],
        order: 3,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: null,
        customComponentKey: 'ambassador_plus_one',
        icon: 'ambassador_plus_one',
        title: 'Ambassador Plus One',
        fullText:
          'Gift Marriott Bonvoy Ambassador Elite status to a household member when you reach 100 nights and $40,000 USD in annual qualified spend.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_DETAILS_CTA_TEXT_MORE_DETAILS',
        ctaLink: 'https://plusone.marriott.com/',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 4,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'hertz_gold_plus_rewards',
        icon: 'car_rental',
        title: 'Hertz President’s Circle®',
        fullText: 'Get the status you deserve with complimentary Hertz Gold Plus Rewards® elite status.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://mrhertzstatus.com/MemberStat',
        benefitDisclaimer: 'Available to members in US and Canada',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'President’s Circle®',
        benefitCode: null,
        modalTable: [
          {
            title: 'Hertz Fast Track to Five Star®',
            subtitle: 'Fast Track to Five Star®',
            activeTiers: ['Platinum'],
          },
          {
            title: 'Hertz Five Star®',
            subtitle: 'Five Star®',
            activeTiers: ['Titanium'],
          },
        ],
        order: 4,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Basic', 'Gold', 'Platinum', 'Silver', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: null,
        customComponentKey: 'sixt_status_match',
        icon: 'car_rental',
        title: 'SIXT Status Match',
        fullText:
          'From your car rental to your hotel reservation, stay on the same level. Enjoy the benefits of matching your status with Marriott Bonvoy® and SIXT. Each offers their own great benefits, making your journey more premium.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_DETAILS_CTA_TEXT_MORE_DETAILS',
        ctaLink: 'https://www.sixt.com/services/#/b2bregistration?b2b_token=4b11c5e4-4394-0597-5e8a-02c2763f5d00',
        benefitDisclaimer: 'Available to members outside the US and Canada',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: true,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'SIXT Express Card',
            subtitle: 'SIXT Express Card',
            activeTiers: ['Silver'],
          },
          {
            title: 'SIXT Gold Card',
            subtitle: 'SIXT Gold Card',
            activeTiers: ['Gold', 'Platinum'],
          },
          {
            title: 'SIXT Diamond Card',
            subtitle: 'SIXT Diamond Card',
            activeTiers: ['Ambassador', 'Titanium'],
          },
        ],
        order: 6,
      },
      {
        _variation: 'master',
        activeTiers: ['Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'ultimate_reservation_guarantee',
        icon: 'ultimate_reservation_guarantee',
        title: 'Ultimate Reservation Guarantee',
        fullText:
          'If we can’t honor your reservation, we’ll pay for you to stay nearby and compensate you for the inconvenience.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: '/loyalty/member-benefits/guarantee.mi ',
        benefitAlert: 'Silver Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 5,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'late_checkout',
        icon: 'late_check_out',
        title: '4 p.m. Late Checkout',
        fullText: 'Request Late Checkout and spend more time exploring the sites or relaxing. Exceptions apply.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: '*Based on availability',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Late Checkout',
        benefitCode: null,
        modalTable: [
          {
            title: 'Priority Late Checkout',
            subtitle: 'Priority Late*',
            activeTiers: ['Silver'],
          },
          {
            title: '2 p.m. Late Checkout',
            subtitle: 'Up to 2 p.m.*',
            activeTiers: ['Gold'],
          },
        ],
        order: 6,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'welcome_gift',
        icon: 'gift',
        title: 'Welcome Gift',
        fullText: 'Receive a special gift upon arrival at participating hotels. Gifts vary by brand and region.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Pionts',
            subtitle: 'Pionts',
            activeTiers: ['Gold'],
          },
          {
            title: 'Points, Breakfast Offering, or Amenity',
            subtitle: 'Points, Breakfast Offering, or Amenity',
            activeTiers: ['Platinum'],
          },
        ],
        order: 7,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'enhanced_room_upgrade',
        icon: 'all_suite_room',
        title: 'Enhanced Room Upgrade',
        fullText:
          'Enjoy a room upgrade for the entire length of your stay. For Platinum Elite members and above this includes select suites.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'Based on availability upon arrival at participating properties, for the entire length of stay.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Room Upgrade',
            subtitle: 'Room Upgrade',
            activeTiers: ['Gold'],
          },
          {
            title: 'Select Suites',
            subtitle: 'Select Suites',
            activeTiers: ['Platinum'],
          },
        ],
        order: 8,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'lounge_access',
        icon: 'lounge_access',
        title: 'Lounge Access',
        fullText: 'At hotel brands with lounges, full lounge access and complimentary breakfast based on availability.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 9,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'annual_choice_benefit',
        icon: 'gift',
        title: 'Annual Choice Benefit',
        fullText: 'Earn 50 and/or 75 Elite Night Credits to select an additional benefit.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://choice-benefit.marriott.com/en-us',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 10,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Titanium'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: '48_hour_guarantee',
        icon: '48_hour_guarantee',
        title: '48-Hour Guarantee',
        fullText: "Book by 3 p.m., 48 hours prior to arrival, and we'll always have a room available to you.",
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Titanium Elite members and above',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 11,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'dedicated_elite_support',
        icon: 'service_request',
        title: 'Dedicated Elite Support',
        fullText: 'Receive 24/7 service for all your hotel booking needs.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 12,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'emirates_skywards',
        icon: 'airport',
        title: 'Emirates Skywards',
        fullText:
          'Earn miles on stays and points on flights, plus Platinum Elite members and above can enjoy priority check-in and boarding with Emirates.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://your-world-rewards.marriott.com/',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Earn Miles + Points',
            subtitle: 'Earn Miles + Points',
            activeTiers: ['Gold'],
          },
          {
            title: 'Priority Check-In and Boarding',
            subtitle: 'Priority Check-In and Boarding',
            activeTiers: ['Platinum'],
          },
        ],
        order: 13,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Titanium'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'united_mileage_plus',
        icon: 'airport',
        title: 'United MileagePlus®',
        fullText:
          'Receive enhanced benefits and Premier® Silver status through our partnership with United MileagePlus®.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://travel-partner.marriott.com/united/en-us',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Titanium Elite members and above',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 14,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'complimentary_wifi',
        icon: 'wifi',
        title: 'Complimentary Wi-Fi',
        fullText: 'Stay connected. Members enjoy complimentary Wi-Fi.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 15,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'exclusive_member_rates',
        icon: 'member_rates',
        title: 'Exclusive Member Rates',
        fullText: 'Enjoy exclusive discounted rates for Marriott Bonvoy Members.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 16,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'instant_redemption',
        icon: 'gift_points',
        title: 'Instant Redemption',
        fullText:
          'During your stay at any of our participating hotels, instantly redeem points for cocktails, meals, spa experiences and more — anything you can charge to your hotel room.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/redeem.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 17,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'cash_points',
        icon: 'cash_and_points',
        title: 'Cash + Points',
        fullText:
          'Book and pay for your room by combining cash and points — stay for as little as $55 and 3,500 points.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/redeem/hotels/cash-points.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 18,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'mobile_checkin',
        icon: 'keyless_entry',
        title: 'Mobile Check-in & Mobile Key',
        fullText: 'Use our app to check in and out, then use your phone as your room key.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 19,
      },
    ],
  },
  {
    tier: 'Basic',
    tierTag: ['mcom-common-spa:mobile/member-tiers/basic'],
    benefits: [
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'complimentary_wifi',
        icon: 'wifi',
        title: 'Complimentary Wi-Fi',
        fullText: 'Stay connected. Members enjoy complimentary Wi-Fi.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 15,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'exclusive_member_rates',
        icon: 'member_rates',
        title: 'Exclusive Member Rates',
        fullText: 'Enjoy exclusive discounted rates for Marriott Bonvoy Members.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 16,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'mobile_checkin',
        icon: 'keyless_entry',
        title: 'Mobile Check-in & Mobile Key',
        fullText: 'Use our app to check in and out, then use your phone as your room key.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 19,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'instant_redemption',
        icon: 'gift_points',
        title: 'Instant Redemption',
        fullText:
          'During your stay at any of our participating hotels, instantly redeem points for cocktails, meals, spa experiences and more — anything you can charge to your hotel room.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/redeem.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 17,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'cash_points',
        icon: 'cash_and_points',
        title: 'Cash + Points',
        fullText:
          'Book and pay for your room by combining cash and points — stay for as little as $55 and 3,500 points.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/redeem/hotels/cash-points.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 18,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Basic', 'Gold', 'Platinum', 'Silver', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: null,
        customComponentKey: 'sixt_status_match',
        icon: 'car_rental',
        title: 'SIXT Status Match',
        fullText:
          'From your car rental to your hotel reservation, stay on the same level. Enjoy the benefits of matching your status with Marriott Bonvoy® and SIXT. Each offers their own great benefits, making your journey more premium.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_DETAILS_CTA_TEXT_MORE_DETAILS',
        ctaLink: 'https://www.sixt.com/services/#/b2bregistration?b2b_token=4b11c5e4-4394-0597-5e8a-02c2763f5d00',
        benefitDisclaimer: 'Available to members outside the US and Canada',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: true,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'SIXT Express Card',
            subtitle: 'SIXT Express Card',
            activeTiers: ['Silver'],
          },
          {
            title: 'SIXT Gold Card',
            subtitle: 'SIXT Gold Card',
            activeTiers: ['Gold', 'Platinum'],
          },
          {
            title: 'SIXT Diamond Card',
            subtitle: 'SIXT Diamond Card',
            activeTiers: ['Ambassador', 'Titanium'],
          },
        ],
        order: 6,
      },
      {
        _variation: 'master',
        activeTiers: ['Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'ultimate_reservation_guarantee',
        icon: 'ultimate_reservation_guarantee',
        title: 'Ultimate Reservation Guarantee',
        fullText:
          'If we can’t honor your reservation, we’ll pay for you to stay nearby and compensate you for the inconvenience.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi ',
        benefitAlert: 'Silver Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 5,
      },
      {
        _variation: 'master',
        activeTiers: ['Silver'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'bonus_points',
        icon: 'more_points_on_stays',
        title: '10% Bonus Points',
        fullText: 'Earn bonus points on eligible hotel purchases.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'To be eligible, you must provide your member number when making a reservation. Compensation varies by hotel brand.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: 'Bonus Points',
        benefitCode: null,
        modalTable: [
          {
            title: '25% Bonus Points',
            subtitle: '25% Bonus Points',
            activeTiers: ['Gold'],
          },
          {
            title: '50% Bonus Points',
            subtitle: '50% Bonus Points',
            activeTiers: ['Platinum'],
          },
          {
            title: '75% Bonus Points',
            subtitle: '75% Bonus Points',
            activeTiers: ['Titanium', 'Ambassador'],
          },
        ],
        order: 7,
      },
      {
        _variation: 'master',
        activeTiers: ['Gold'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'bonus_points',
        icon: 'more_points_on_stays',
        title: '25% Bonus Points',
        fullText: 'Earn bonus points on eligible hotel purchases.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'To be eligible, you must provide your member number when making a reservation. Compensation varies by hotel brand.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: 'Bonus Points',
        benefitCode: null,
        modalTable: [
          {
            title: '10% Bonus Points',
            subtitle: '1Bonus Points',
            activeTiers: ['Silver'],
          },
          {
            title: '50% Bonus Points',
            subtitle: 'Bonus Points',
            activeTiers: ['Platinum'],
          },
          {
            title: '75% Bonus Points',
            subtitle: 'Bonus Points',
            activeTiers: ['Titanium', 'Ambassador'],
          },
        ],
        order: 8,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'bonus_points',
        icon: 'more_points_on_stays',
        title: '50% Bonus Points',
        fullText: 'Earn bonus points on eligible hotel purchases.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'To be eligible, you must provide your member number when making a reservation. Compensation varies by hotel brand.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: 'Bonus Points',
        benefitCode: null,
        modalTable: [
          {
            title: '10% Bonus Points',
            subtitle: '10% Bonus Points',
            activeTiers: ['Silver'],
          },
          {
            title: '25% Bonus Points',
            subtitle: '25% Bonus Points',
            activeTiers: ['Gold'],
          },
          {
            title: '75% Bonus Points',
            subtitle: '75% Bonus Points',
            activeTiers: ['Titanium', 'Ambassador'],
          },
        ],
        order: 9,
      },
      {
        _variation: 'master',
        activeTiers: ['Titanium', 'Ambassador'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'bonus_points',
        icon: 'more_points_on_stays',
        title: '10% Bonus Points',
        fullText: 'Earn bonus points on eligible hotel purchases.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'To be eligible, you must provide your member number when making a reservation. Compensation varies by hotel brand.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: '10% Bonus Points',
        benefitCode: null,
        modalTable: [
          {
            title: '10% Bonus Points',
            subtitle: '10% Bonus Points',
            activeTiers: ['Silver'],
          },
          {
            title: '25% Bonus Points',
            subtitle: '25% Bonus Points',
            activeTiers: ['Gold'],
          },
          {
            title: '50% Bonus Points',
            subtitle: '50% Bonus Points',
            activeTiers: ['Platinum'],
          },
        ],
        order: 3,
      },
      {
        _variation: 'master',
        activeTiers: ['Silver'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'late_checkout',
        icon: 'late_check_out',
        title: 'Priority Late Checkout',
        fullText: 'Request Late Checkout and spend more time exploring the sites or relaxing. Exceptions apply.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: '*Based on availability',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Late Checkout',
        benefitCode: null,
        modalTable: [
          {
            title: '2 p.m. Late Checkout',
            subtitle: 'Up to 2 p.m.*',
            activeTiers: ['Gold'],
          },
          {
            title: '4 p.m. Late Checkout',
            subtitle: 'Up to 4 p.m.*',
            activeTiers: ['Ambassador', 'Platinum', 'Titanium'],
          },
        ],
        order: 11,
      },
      {
        _variation: 'master',
        activeTiers: ['Gold'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'late_checkout',
        icon: 'late_check_out',
        title: '2 p.m. Late Checkout',
        fullText: 'Request Late Checkout and spend more time exploring the sites or relaxing. Exceptions apply.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: '*Based on availability',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Late Checkout',
        benefitCode: null,
        modalTable: [
          {
            title: 'Priority Late Checkout',
            subtitle: 'Priority Late*',
            activeTiers: ['Silver'],
          },
          {
            title: '4 p.m. Late Checkout',
            subtitle: 'Up to 4 p.m.*',
            activeTiers: ['Ambassador', 'Platinum', 'Titanium'],
          },
        ],
        order: 12,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'late_checkout',
        icon: 'late_check_out',
        title: '4 p.m. Late Checkout',
        fullText: 'Request Late Checkout and spend more time exploring the sites or relaxing. Exceptions apply.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: '*Based on availability',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Late Checkout',
        benefitCode: null,
        modalTable: [
          {
            title: 'Priority Late Checkout',
            subtitle: 'Priority Late*',
            activeTiers: ['Silver'],
          },
          {
            title: '2 p.m. Late Checkout',
            subtitle: 'Up to 2 p.m.*',
            activeTiers: ['Gold'],
          },
        ],
        order: 6,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'welcome_gift',
        icon: 'gift',
        title: 'Welcome Gift',
        fullText: 'Receive a special gift upon arrival at participating hotels. Gifts vary by brand and region.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Pionts',
            subtitle: 'Pionts',
            activeTiers: ['Gold'],
          },
          {
            title: 'Points, Breakfast Offering, or Amenity',
            subtitle: 'Points, Breakfast Offering, or Amenity',
            activeTiers: ['Platinum'],
          },
        ],
        order: 7,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'enhanced_room_upgrade',
        icon: 'all_suite_room',
        title: 'Enhanced Room Upgrade',
        fullText:
          'Enjoy a room upgrade for the entire length of your stay. For Platinum Elite members and above this includes select suites.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'Based on availability upon arrival at participating properties, for the entire length of stay.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Room Upgrade',
            subtitle: 'Room Upgrade',
            activeTiers: ['Gold'],
          },
          {
            title: 'Select Suites',
            subtitle: 'Select Suites',
            activeTiers: ['Platinum'],
          },
        ],
        order: 8,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'dedicated_elite_support',
        icon: 'service_request',
        title: 'Dedicated Elite Support',
        fullText: 'Receive 24/7 service for all your hotel booking needs.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 12,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'lounge_access',
        icon: 'lounge_access',
        title: 'Lounge Access',
        fullText: 'At hotel brands with lounges, full lounge access and complimentary breakfast based on availability.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 9,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'annual_choice_benefit',
        icon: 'gift',
        title: 'Annual Choice Benefit',
        fullText: 'Earn 50 and/or 75 Elite Night Credits to select an additional benefit.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://choice-benefit.marriott.com/en-us',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 10,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Titanium'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: '48_hour_guarantee',
        icon: '48_hour_guarantee',
        title: '48-Hour Guarantee',
        fullText: "Book by 3 p.m., 48 hours prior to arrival, and we'll always have a room available to you.",
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Titanium Elite members and above',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 11,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'your_24',
        icon: 'your_24',
        title: 'Your24™',
        fullText:
          'Choose your check-in time and keep your room until the same time on the day of departure. Request via Ambassador Service 2 days prior to arrival.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: 'Based on availability. Property and brand exceptions apply.',
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 2,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'ambassador_service',
        icon: 'ambassador',
        title: 'Ambassador Service',
        fullText: 'Dedicated Personal Ambassador to assist you with all of your travel needs.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 1,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: null,
        customComponentKey: 'ambassador_plus_one',
        icon: 'ambassador_plus_one',
        title: 'Ambassador Plus One',
        fullText:
          'Gift Marriott Bonvoy Ambassador Elite status to a household member when you reach 100 nights and $40,000 USD in annual qualified spend.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_DETAILS_CTA_TEXT_MORE_DETAILS',
        ctaLink: 'https://plusone.marriott.com/',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 4,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'emirates_skywards',
        icon: 'airport',
        title: 'Emirates Skywards',
        fullText:
          'Earn miles on stays and points on flights, plus Platinum Elite members and above can enjoy priority check-in and boarding with Emirates.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://your-world-rewards.marriott.com/',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Earn Miles + Points',
            subtitle: 'Earn Miles + Points',
            activeTiers: ['Gold'],
          },
          {
            title: 'Priority Check-In and Boarding',
            subtitle: 'Priority Check-In and Boarding',
            activeTiers: ['Platinum'],
          },
        ],
        order: 13,
      },
      {
        _variation: 'master',
        activeTiers: null,
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'hertz_gold_plus_rewards',
        icon: 'car_rental',
        title: 'Hertz Gold Plus Rewards®',
        fullText: 'Get the status you deserve with complimentary Hertz Gold Plus Rewards® elite status.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://mrhertzstatus.com/MemberStat',
        benefitDisclaimer: 'Available to members in US and Canada',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Hertz Gold Plus Rewards®',
        benefitCode: null,
        modalTable: [
          {
            title: 'Hertz Fast Track to Five Star®',
            subtitle: 'Fast Track to Five Star®',
            activeTiers: ['Platinum'],
          },
          {
            title: 'Hertz Five Star®',
            subtitle: 'Five Star®',
            activeTiers: ['Titanium'],
          },
          {
            title: 'Hertz President’s Circle®',
            subtitle: 'President’s Circle®',
            activeTiers: ['Ambassador'],
          },
        ],
        order: 23,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Titanium'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'united_mileage_plus',
        icon: 'airport',
        title: 'United MileagePlus®',
        fullText:
          'Receive enhanced benefits and Premier® Silver status through our partnership with United MileagePlus®.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://travel-partner.marriott.com/united/en-us',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Titanium Elite members and above',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 14,
      },
    ],
  },
  {
    tier: 'Gold',
    tierTag: ['mcom-common-spa:mobile/member-tiers/gold'],
    benefits: [
      {
        _variation: 'master',
        activeTiers: ['Gold'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'bonus_points',
        icon: 'more_points_on_stays',
        title: '25% Bonus Points',
        fullText: 'Earn bonus points on eligible hotel purchases.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'To be eligible, you must provide your member number when making a reservation. Compensation varies by hotel brand.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: 'Bonus Points',
        benefitCode: null,
        modalTable: [
          {
            title: '10% Bonus Points',
            subtitle: '10% Bonus Points',
            activeTiers: ['Silver'],
          },
          {
            title: '50% Bonus Points',
            subtitle: '50% Bonus Points',
            activeTiers: ['Platinum'],
          },
          {
            title: '75% Bonus Points',
            subtitle: '75% Bonus Points',
            activeTiers: ['Titanium', 'Ambassador'],
          },
        ],
        order: 8,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'enhanced_room_upgrade',
        icon: 'all_suite_room',
        title: 'Enhanced Room Upgrade',
        fullText:
          'Enjoy a room upgrade for the entire length of your stay. For Platinum Elite members and above this includes select suites.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'Based on availability upon arrival at participating properties, for the entire length of stay.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Room Upgrade',
            subtitle: 'Room Upgrade',
            activeTiers: ['Gold'],
          },
          {
            title: 'Select Suites',
            subtitle: 'Select Suites',
            activeTiers: ['Platinum'],
          },
        ],
        order: 8,
      },
      {
        _variation: 'master',
        activeTiers: ['Gold'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'late_checkout',
        icon: 'late_check_out',
        title: '2 p.m. Late Checkout',
        fullText: 'Request Late Checkout and spend more time exploring the sites or relaxing. Exceptions apply.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: '*Based on availability',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Late Checkout',
        benefitCode: null,
        modalTable: [
          {
            title: 'Priority Late Checkout',
            subtitle: 'Priority Late*',
            activeTiers: ['Silver'],
          },
          {
            title: '4 p.m. Late Checkout',
            subtitle: 'Up to 4 p.m.*',
            activeTiers: ['Ambassador', 'Platinum', 'Titanium'],
          },
        ],
        order: 12,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'welcome_gift',
        icon: 'gift',
        title: 'Welcome Gift',
        fullText: 'Receive a special gift upon arrival at participating hotels. Gifts vary by brand and region.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Pionts',
            subtitle: 'Pionts',
            activeTiers: ['Gold'],
          },
          {
            title: 'Points, Breakfast Offering, or Amenity',
            subtitle: 'Points, Breakfast Offering, or Amenity',
            activeTiers: ['Platinum'],
          },
        ],
        order: 7,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'emirates_skywards',
        icon: 'airport',
        title: 'Emirates Skywards',
        fullText:
          'Earn miles on stays and points on flights, plus Platinum Elite members and above can enjoy priority check-in and boarding with Emirates.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://your-world-rewards.marriott.com/',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Earn Miles + Points',
            subtitle: 'Earn Miles + Points',
            activeTiers: ['Gold'],
          },
          {
            title: 'Priority Check-In and Boarding',
            subtitle: 'Priority Check-In and Boarding',
            activeTiers: ['Platinum'],
          },
        ],
        order: 13,
      },
      {
        _variation: 'master',
        activeTiers: ['Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'ultimate_reservation_guarantee',
        icon: 'ultimate_reservation_guarantee',
        title: 'Ultimate Reservation Guarantee',
        fullText:
          'If we can’t honor your reservation, we’ll pay for you to stay nearby and compensate you for the inconvenience.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi ',
        benefitAlert: 'Silver Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 5,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'exclusive_member_rates',
        icon: 'member_rates',
        title: 'Exclusive Member Rates',
        fullText: 'Enjoy exclusive discounted rates for Marriott Bonvoy Members.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 16,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'complimentary_wifi',
        icon: 'wifi',
        title: 'Complimentary Wi-Fi',
        fullText: 'Stay connected. Members enjoy complimentary Wi-Fi.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 15,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'instant_redemption',
        icon: 'gift_points',
        title: 'Instant Redemption',
        fullText:
          'During your stay at any of our participating hotels, instantly redeem points for cocktails, meals, spa experiences and more — anything you can charge to your hotel room.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/redeem.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 17,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'cash_points',
        icon: 'cash_and_points',
        title: 'Cash + Points',
        fullText:
          'Book and pay for your room by combining cash and points — stay for as little as $55 and 3,500 points.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/redeem/hotels/cash-points.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 18,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'mobile_checkin',
        icon: 'keyless_entry',
        title: 'Mobile Check-in & Mobile Key',
        fullText: 'Use our app to check in and out, then use your phone as your room key.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 19,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Basic', 'Gold', 'Platinum', 'Silver', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: null,
        customComponentKey: 'sixt_status_match',
        icon: 'car_rental',
        title: 'SIXT Status Match',
        fullText:
          'From your car rental to your hotel reservation, stay on the same level. Enjoy the benefits of matching your status with Marriott Bonvoy® and SIXT. Each offers their own great benefits, making your journey more premium.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_DETAILS_CTA_TEXT_MORE_DETAILS',
        ctaLink: 'https://www.sixt.com/services/#/b2bregistration?b2b_token=4b11c5e4-4394-0597-5e8a-02c2763f5d00',
        benefitDisclaimer: 'Available to members outside the US and Canada',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: true,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'SIXT Express Card',
            subtitle: 'SIXT Express Card',
            activeTiers: ['Silver'],
          },
          {
            title: 'SIXT Gold Card',
            subtitle: 'SIXT Gold Card',
            activeTiers: ['Gold', 'Platinum'],
          },
          {
            title: 'SIXT Diamond Card',
            subtitle: 'SIXT Diamond Card',
            activeTiers: ['Ambassador', 'Titanium'],
          },
        ],
        order: 6,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'bonus_points',
        icon: 'more_points_on_stays',
        title: '50% Bonus Points',
        fullText: 'Earn bonus points on eligible hotel purchases.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'To be eligible, you must provide your member number when making a reservation. Compensation varies by hotel brand.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: 'Bonus Points',
        benefitCode: null,
        modalTable: [
          {
            title: '10% Bonus Points',
            subtitle: '10% Bonus Points',
            activeTiers: ['Silver'],
          },
          {
            title: '25% Bonus Points',
            subtitle: '25% Bonus Points',
            activeTiers: ['Gold'],
          },
          {
            title: '75% Bonus Points',
            subtitle: '75% Bonus Points',
            activeTiers: ['Titanium', 'Ambassador'],
          },
        ],
        order: 9,
      },
      {
        _variation: 'master',
        activeTiers: ['Titanium', 'Ambassador'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'bonus_points',
        icon: 'more_points_on_stays',
        title: '75% Bonus Points',
        fullText: 'Earn bonus points on eligible hotel purchases.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'To be eligible, you must provide your member number when making a reservation. Compensation varies by hotel brand.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: '75% Bonus Points',
        benefitCode: null,
        modalTable: [
          {
            title: '10% Bonus Points',
            subtitle: '10% Bonus Points',
            activeTiers: ['Silver'],
          },
          {
            title: '25% Bonus Points',
            subtitle: '25% Bonus Points',
            activeTiers: ['Gold'],
          },
          {
            title: '50% Bonus Points',
            subtitle: '50% Bonus Points',
            activeTiers: ['Platinum'],
          },
        ],
        order: 3,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'late_checkout',
        icon: 'late_check_out',
        title: '4 p.m. Late Checkout',
        fullText: 'Request Late Checkout and spend more time exploring the sites or relaxing. Exceptions apply.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: '*Based on availability',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Late Checkout',
        benefitCode: null,
        modalTable: [
          {
            title: 'Priority Late Checkout',
            subtitle: 'Priority Late*',
            activeTiers: ['Silver'],
          },
          {
            title: '2 p.m. Late Checkout',
            subtitle: 'Up to 2 p.m.*',
            activeTiers: ['Gold'],
          },
        ],
        order: 6,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'dedicated_elite_support',
        icon: 'service_request',
        title: 'Dedicated Elite Support',
        fullText: 'Receive 24/7 service for all your hotel booking needs.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 12,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'lounge_access',
        icon: 'lounge_access',
        title: 'Lounge Access',
        fullText: 'At hotel brands with lounges, full lounge access and complimentary breakfast based on availability.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 9,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'annual_choice_benefit',
        icon: 'gift',
        title: 'Annual Choice Benefit',
        fullText: 'Earn 50 and/or 75 Elite Night Credits to select an additional benefit.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://choice-benefit.marriott.com/en-us',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 10,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Titanium'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: '48_hour_guarantee',
        icon: '48_hour_guarantee',
        title: '48-Hour Guarantee',
        fullText: "Book by 3 p.m., 48 hours prior to arrival, and we'll always have a room available to you.",
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Titanium Elite members and above',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 11,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'your_24',
        icon: 'your_24',
        title: 'Your24™',
        fullText:
          'Choose your check-in time and keep your room until the same time on the day of departure. Request via Ambassador Service 2 days prior to arrival.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: 'Based on availability. Property and brand exceptions apply.',
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 2,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'ambassador_service',
        icon: 'ambassador',
        title: 'Ambassador Service',
        fullText: 'Dedicated Personal Ambassador to assist you with all of your travel needs.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 1,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: null,
        customComponentKey: 'ambassador_plus_one',
        icon: 'ambassador_plus_one',
        title: 'Ambassador Plus One',
        fullText:
          'Gift Marriott Bonvoy Ambassador Elite status to a household member when you reach 100 nights and $40,000 USD in annual qualified spend.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_DETAILS_CTA_TEXT_MORE_DETAILS',
        ctaLink: 'https://plusone.marriott.com/',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 4,
      },
      {
        _variation: 'master',
        activeTiers: null,
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'hertz_gold_plus_rewards',
        icon: 'car_rental',
        title: 'Hertz Gold Plus Rewards®',
        fullText: 'Get the status you deserve with complimentary Hertz Gold Plus Rewards® elite status.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://mrhertzstatus.com/MemberStat',
        benefitDisclaimer: 'Available to members in US and Canada',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Hertz Gold Plus Rewards®',
        benefitCode: null,
        modalTable: [
          {
            title: 'Hertz Fast Track to Five Star®',
            subtitle: 'Fast Track to Five Star®',
            activeTiers: ['Platinum'],
          },
          {
            title: 'Hertz Five Star®',
            subtitle: 'Five Star®',
            activeTiers: ['Titanium'],
          },
          {
            title: 'Hertz President’s Circle®',
            subtitle: 'President’s Circle®',
            activeTiers: ['Ambassador'],
          },
        ],
        order: 23,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Titanium'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'united_mileage_plus',
        icon: 'airport',
        title: 'United MileagePlus®',
        fullText:
          'Receive enhanced benefits and Premier® Silver status through our partnership with United MileagePlus®.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://travel-partner.marriott.com/united/en-us',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Titanium Elite members and above',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 14,
      },
    ],
  },
  {
    tier: 'Platinum',
    tierTag: ['mcom-common-spa:mobile/member-tiers/platinum'],
    benefits: [
      {
        _variation: 'master',
        activeTiers: ['Platinum'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'bonus_points',
        icon: 'more_points_on_stays',
        title: '50% Bonus Points',
        fullText: 'Earn bonus points on eligible hotel purchases.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'To be eligible, you must provide your member number when making a reservation. Compensation varies by hotel brand.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: 'Bonus Points',
        benefitCode: null,
        modalTable: [
          {
            title: '10% Bonus Points',
            subtitle: '10% Bonus Points',
            activeTiers: ['Silver'],
          },
          {
            title: '25% Bonus Points',
            subtitle: '25% Bonus Points',
            activeTiers: ['Gold'],
          },
          {
            title: '75% Bonus Points',
            subtitle: '75% Bonus Points',
            activeTiers: ['Titanium', 'Ambassador'],
          },
        ],
        order: 9,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'enhanced_room_upgrade',
        icon: 'all_suite_room',
        title: 'Enhanced Room Upgrade',
        fullText:
          'Enjoy a room upgrade for the entire length of your stay. For Platinum Elite members and above this includes select suites.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'Based on availability upon arrival at participating properties, for the entire length of stay.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Room Upgrade',
            subtitle: 'Room Upgrade',
            activeTiers: ['Gold'],
          },
          {
            title: 'Select Suites',
            subtitle: 'Select Suites',
            activeTiers: ['Platinum'],
          },
        ],
        order: 8,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'welcome_gift',
        icon: 'gift',
        title: 'Welcome Gift',
        fullText: 'Receive a special gift upon arrival at participating hotels. Gifts vary by brand and region.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Pionts',
            subtitle: 'Pionts',
            activeTiers: ['Gold'],
          },
          {
            title: 'Points, Breakfast Offering, or Amenity',
            subtitle: 'Points, Breakfast Offering, or Amenity',
            activeTiers: ['Platinum'],
          },
        ],
        order: 7,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'late_checkout',
        icon: 'late_check_out',
        title: '4 p.m. Late Checkout',
        fullText: 'Request Late Checkout and spend more time exploring the sites or relaxing. Exceptions apply.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: '*Based on availability',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Late Checkout',
        benefitCode: null,
        modalTable: [
          {
            title: 'Priority Late Checkout',
            subtitle: 'Priority Late*',
            activeTiers: ['Silver'],
          },
          {
            title: '2 p.m. Late Checkout',
            subtitle: 'Up to 2 p.m.*',
            activeTiers: ['Gold'],
          },
        ],
        order: 6,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'dedicated_elite_support',
        icon: 'service_request',
        title: 'Dedicated Elite Support',
        fullText: 'Receive 24/7 service for all your hotel booking needs.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 12,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'lounge_access',
        icon: 'lounge_access',
        title: 'Lounge Access',
        fullText: 'At hotel brands with lounges, full lounge access and complimentary breakfast based on availability.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 9,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'annual_choice_benefit',
        icon: 'gift',
        title: 'Annual Choice Benefit',
        fullText: 'Earn 50 and/or 75 Elite Night Credits to select an additional benefit.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://choice-benefit.marriott.com/en-us',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 10,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'hertz_gold_plus_rewards',
        icon: 'car_rental',
        title: 'Hertz Fast Track to Five Star®',
        fullText: 'Get the status you deserve with complimentary Hertz Gold Plus Rewards® elite status.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://mrhertzstatus.com/MemberStat',
        benefitDisclaimer: 'Available to members in US and Canada',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Fast Track to Five Star®',
        benefitCode: null,
        modalTable: [
          {
            title: 'Hertz Five Star®',
            subtitle: 'Five Star®',
            activeTiers: ['Titanium'],
          },
          {
            title: 'Hertz President’s Circle®',
            subtitle: 'President’s Circle®',
            activeTiers: ['Ambassador'],
          },
        ],
        order: 8,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Basic', 'Gold', 'Platinum', 'Silver', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: null,
        customComponentKey: 'sixt_status_match',
        icon: 'car_rental',
        title: 'SIXT Status Match',
        fullText:
          'From your car rental to your hotel reservation, stay on the same level. Enjoy the benefits of matching your status with Marriott Bonvoy® and SIXT. Each offers their own great benefits, making your journey more premium.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_DETAILS_CTA_TEXT_MORE_DETAILS',
        ctaLink: 'https://www.sixt.com/services/#/b2bregistration?b2b_token=4b11c5e4-4394-0597-5e8a-02c2763f5d00',
        benefitDisclaimer: 'Available to members outside the US and Canada',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: true,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'SIXT Express Card',
            subtitle: 'SIXT Express Card',
            activeTiers: ['Silver'],
          },
          {
            title: 'SIXT Gold Card',
            subtitle: 'SIXT Gold Card',
            activeTiers: ['Gold', 'Platinum'],
          },
          {
            title: 'SIXT Diamond Card',
            subtitle: 'SIXT Diamond Card',
            activeTiers: ['Ambassador', 'Titanium'],
          },
        ],
        order: 6,
      },
      {
        _variation: 'master',
        activeTiers: ['Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'ultimate_reservation_guarantee',
        icon: 'ultimate_reservation_guarantee',
        title: 'Ultimate Reservation Guarantee',
        fullText:
          'If we can’t honor your reservation, we’ll pay for you to stay nearby and compensate you for the inconvenience.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi ',
        benefitAlert: 'Silver Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 5,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'emirates_skywards',
        icon: 'airport',
        title: 'Emirates Skywards',
        fullText:
          'Earn miles on stays and points on flights, plus Platinum Elite members and above can enjoy priority check-in and boarding with Emirates.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://your-world-rewards.marriott.com/',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Earn Miles + Points',
            subtitle: 'Earn Miles + Points',
            activeTiers: ['Gold'],
          },
          {
            title: 'Priority Check-In and Boarding',
            subtitle: 'Priority Check-In and Boarding',
            activeTiers: ['Platinum'],
          },
        ],
        order: 13,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'exclusive_member_rates',
        icon: 'member_rates',
        title: 'Exclusive Member Rates',
        fullText: 'Enjoy exclusive discounted rates for Marriott Bonvoy Members.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 16,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'complimentary_wifi',
        icon: 'wifi',
        title: 'Complimentary Wi-Fi',
        fullText: 'Stay connected. Members enjoy complimentary Wi-Fi.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 15,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'instant_redemption',
        icon: 'gift_points',
        title: 'Instant Redemption',
        fullText:
          'During your stay at any of our participating hotels, instantly redeem points for cocktails, meals, spa experiences and more — anything you can charge to your hotel room.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/redeem.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 17,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'cash_points',
        icon: 'cash_and_points',
        title: 'Cash + Points',
        fullText:
          'Book and pay for your room by combining cash and points — stay for as little as $55 and 3,500 points.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/redeem/hotels/cash-points.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 18,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'mobile_checkin',
        icon: 'keyless_entry',
        title: 'Mobile Check-in & Mobile Key',
        fullText: 'Use our app to check in and out, then use your phone as your room key.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 19,
      },
      {
        _variation: 'master',
        activeTiers: ['Titanium', 'Ambassador'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'bonus_points',
        icon: 'more_points_on_stays',
        title: '75% Bonus Points',
        fullText: 'Earn bonus points on eligible hotel purchases.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'To be eligible, you must provide your member number when making a reservation. Compensation varies by hotel brand.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: '75% Bonus Points',
        benefitCode: null,
        modalTable: [
          {
            title: '10% Bonus Points',
            subtitle: '10% Bonus Points',
            activeTiers: ['Silver'],
          },
          {
            title: '25% Bonus Points',
            subtitle: '25% Bonus Points',
            activeTiers: ['Gold'],
          },
          {
            title: '50% Bonus Points',
            subtitle: '50% Bonus Points',
            activeTiers: ['Platinum'],
          },
        ],
        order: 3,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Titanium'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: '48_hour_guarantee',
        icon: '48_hour_guarantee',
        title: '48-Hour Guarantee',
        fullText: "Book by 3 p.m., 48 hours prior to arrival, and we'll always have a room available to you.",
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Titanium Elite members and above',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 11,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'your_24',
        icon: 'your_24',
        title: 'Your24™',
        fullText:
          'Choose your check-in time and keep your room until the same time on the day of departure. Request via Ambassador Service 2 days prior to arrival.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: 'Based on availability. Property and brand exceptions apply.',
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 2,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'ambassador_service',
        icon: 'ambassador',
        title: 'Ambassador Service',
        fullText: 'Dedicated Personal Ambassador to assist you with all of your travel needs.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 1,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: null,
        customComponentKey: 'ambassador_plus_one',
        icon: 'ambassador_plus_one',
        title: 'Ambassador Plus One',
        fullText:
          'Gift Marriott Bonvoy Ambassador Elite status to a household member when you reach 100 nights and $40,000 USD in annual qualified spend.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_DETAILS_CTA_TEXT_MORE_DETAILS',
        ctaLink: 'https://plusone.marriott.com/',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 4,
      },
      {
        _variation: 'master',
        activeTiers: ['Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'hertz_gold_plus_rewards',
        icon: 'car_rental',
        title: 'Hertz Five Star®',
        fullText: 'Get the status you deserve with complimentary Hertz Gold Plus Rewards® elite status.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://mrhertzstatus.com/MemberStat',
        benefitDisclaimer: 'Available to members in US and Canada',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Five Star®',
        benefitCode: null,
        modalTable: [
          {
            title: 'Hertz Fast Track to Five Star®',
            subtitle: 'Fast Track to Five Star®',
            activeTiers: ['Platinum'],
          },
          {
            title: 'Hertz President’s Circle®',
            subtitle: 'President’s Circle®',
            activeTiers: ['Ambassador'],
          },
        ],
        order: 20,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'hertz_gold_plus_rewards',
        icon: 'car_rental',
        title: 'Hertz President’s Circle®',
        fullText: 'Get the status you deserve with complimentary Hertz Gold Plus Rewards® elite status.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://mrhertzstatus.com/MemberStat',
        benefitDisclaimer: 'Available to members in US and Canada',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'President’s Circle®',
        benefitCode: null,
        modalTable: [
          {
            title: 'Hertz Fast Track to Five Star®',
            subtitle: 'Fast Track to Five Star®',
            activeTiers: ['Platinum'],
          },
          {
            title: 'Hertz Five Star®',
            subtitle: 'Five Star®',
            activeTiers: ['Titanium'],
          },
        ],
        order: 4,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Titanium'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'united_mileage_plus',
        icon: 'airport',
        title: 'United MileagePlus®',
        fullText:
          'Receive enhanced benefits and Premier® Silver status through our partnership with United MileagePlus®.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://travel-partner.marriott.com/united/en-us',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Titanium Elite members and above',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 14,
      },
    ],
  },
  {
    tier: 'Silver',
    tierTag: ['mcom-common-spa:mobile/member-tiers/silver'],
    benefits: [
      {
        _variation: 'master',
        activeTiers: ['Silver'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'bonus_points',
        icon: 'more_points_on_stays',
        title: '10% Bonus Points',
        fullText: 'Earn bonus points on eligible hotel purchases.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'To be eligible, you must provide your member number when making a reservation. Compensation varies by hotel brand.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: 'Bonus Points',
        benefitCode: null,
        modalTable: [
          {
            title: '25% Bonus Points',
            subtitle: '25% Bonus Points',
            activeTiers: ['Gold'],
          },
          {
            title: '50% Bonus Points',
            subtitle: '50% Bonus Points',
            activeTiers: ['Platinum'],
          },
          {
            title: '75% Bonus Points',
            subtitle: '75% Bonus Points',
            activeTiers: ['Titanium', 'Ambassador'],
          },
        ],
        order: 7,
      },
      {
        _variation: 'master',
        activeTiers: ['Silver'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'late_checkout',
        icon: 'late_check_out',
        title: 'Priority Late Checkout',
        fullText: 'Request Late Checkout and spend more time exploring the sites or relaxing. Exceptions apply.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: '*Based on availability',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Late Checkout',
        benefitCode: null,
        modalTable: [
          {
            title: '2 p.m. Late Checkout',
            subtitle: 'Up to 2 p.m.*',
            activeTiers: ['Gold'],
          },
          {
            title: '4 p.m. Late Checkout',
            subtitle: 'Up to 4 p.m.*',
            activeTiers: ['Ambassador', 'Platinum', 'Titanium'],
          },
        ],
        order: 11,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'exclusive_member_rates',
        icon: 'member_rates',
        title: 'Exclusive Member Rates',
        fullText: 'Enjoy exclusive discounted rates for Marriott Bonvoy Members.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 16,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'complimentary_wifi',
        icon: 'wifi',
        title: 'Complimentary Wi-Fi',
        fullText: 'Stay connected. Members enjoy complimentary Wi-Fi.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 15,
      },
      {
        _variation: 'master',
        activeTiers: ['Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'ultimate_reservation_guarantee',
        icon: 'ultimate_reservation_guarantee',
        title: 'Ultimate Reservation Guarantee',
        fullText:
          'If we can’t honor your reservation, we’ll pay for you to stay nearby and compensate you for the inconvenience.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi ',
        benefitAlert: 'Silver Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 5,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'cash_points',
        icon: 'cash_and_points',
        title: 'Cash + Points',
        fullText:
          'Book and pay for your room by combining cash and points — stay for as little as $55 and 3,500 points.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/redeem/hotels/cash-points.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 18,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'mobile_checkin',
        icon: 'keyless_entry',
        title: 'Mobile Check-in & Mobile Key',
        fullText: 'Use our app to check in and out, then use your phone as your room key.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 19,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'instant_redemption',
        icon: 'gift_points',
        title: 'Instant Redemption',
        fullText:
          'During your stay at any of our participating hotels, instantly redeem points for cocktails, meals, spa experiences and more — anything you can charge to your hotel room.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/redeem.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 17,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Basic', 'Gold', 'Platinum', 'Silver', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: null,
        customComponentKey: 'sixt_status_match',
        icon: 'car_rental',
        title: 'SIXT Status Match',
        fullText:
          'From your car rental to your hotel reservation, stay on the same level. Enjoy the benefits of matching your status with Marriott Bonvoy® and SIXT. Each offers their own great benefits, making your journey more premium.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_DETAILS_CTA_TEXT_MORE_DETAILS',
        ctaLink: 'https://www.sixt.com/services/#/b2bregistration?b2b_token=4b11c5e4-4394-0597-5e8a-02c2763f5d00',
        benefitDisclaimer: 'Available to members outside the US and Canada',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: true,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'SIXT Express Card',
            subtitle: 'SIXT Express Card',
            activeTiers: ['Silver'],
          },
          {
            title: 'SIXT Gold Card',
            subtitle: 'SIXT Gold Card',
            activeTiers: ['Gold', 'Platinum'],
          },
          {
            title: 'SIXT Diamond Card',
            subtitle: 'SIXT Diamond Card',
            activeTiers: ['Ambassador', 'Titanium'],
          },
        ],
        order: 6,
      },
      {
        _variation: 'master',
        activeTiers: ['Gold'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'bonus_points',
        icon: 'more_points_on_stays',
        title: '25% Bonus Points',
        fullText: 'Earn bonus points on eligible hotel purchases.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'To be eligible, you must provide your member number when making a reservation. Compensation varies by hotel brand.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: 'Bonus Points',
        benefitCode: null,
        modalTable: [
          {
            title: '10% Bonus Points',
            subtitle: '10% Bonus Points',
            activeTiers: ['Silver'],
          },
          {
            title: '50% Bonus Points',
            subtitle: '50% Bonus Points',
            activeTiers: ['Platinum'],
          },
          {
            title: '75% Bonus Points',
            subtitle: '75% Bonus Points',
            activeTiers: ['Titanium', 'Ambassador'],
          },
        ],
        order: 8,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'bonus_points',
        icon: 'more_points_on_stays',
        title: '50% Bonus Points',
        fullText: 'Earn bonus points on eligible hotel purchases.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'To be eligible, you must provide your member number when making a reservation. Compensation varies by hotel brand.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: 'Bonus Points',
        benefitCode: null,
        modalTable: [
          {
            title: '10% Bonus Points',
            subtitle: '10% Bonus Points',
            activeTiers: ['Silver'],
          },
          {
            title: '25% Bonus Points',
            subtitle: '25% Bonus Points',
            activeTiers: ['Gold'],
          },
          {
            title: '75% Bonus Points',
            subtitle: '75% Bonus Points',
            activeTiers: ['Titanium', 'Ambassador'],
          },
        ],
        order: 9,
      },
      {
        _variation: 'master',
        activeTiers: ['Titanium', 'Ambassador'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'bonus_points',
        icon: 'more_points_on_stays',
        title: '75% Bonus Points',
        fullText: 'Earn bonus points on eligible hotel purchases.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'To be eligible, you must provide your member number when making a reservation. Compensation varies by hotel brand.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: '75% Bonus Points',
        benefitCode: null,
        modalTable: [
          {
            title: '10% Bonus Points',
            subtitle: '10% Bonus Points',
            activeTiers: ['Silver'],
          },
          {
            title: '25% Bonus Points',
            subtitle: '25% Bonus Points',
            activeTiers: ['Gold'],
          },
          {
            title: '50% Bonus Points',
            subtitle: '50% Bonus Points',
            activeTiers: ['Platinum'],
          },
        ],
        order: 3,
      },
      {
        _variation: 'master',
        activeTiers: ['Gold'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'late_checkout',
        icon: 'late_check_out',
        title: '2 p.m. Late Checkout',
        fullText: 'Request Late Checkout and spend more time exploring the sites or relaxing. Exceptions apply.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: '*Based on availability',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Late Checkout',
        benefitCode: null,
        modalTable: [
          {
            title: 'Priority Late Checkout',
            subtitle: 'Priority Late*',
            activeTiers: ['Silver'],
          },
          {
            title: '4 p.m. Late Checkout',
            subtitle: 'Up to 4 p.m.*',
            activeTiers: ['Ambassador', 'Platinum', 'Titanium'],
          },
        ],
        order: 12,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'late_checkout',
        icon: 'late_check_out',
        title: '4 p.m. Late Checkout',
        fullText: 'Request Late Checkout and spend more time exploring the sites or relaxing. Exceptions apply.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: '*Based on availability',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Late Checkout',
        benefitCode: null,
        modalTable: [
          {
            title: 'Priority Late Checkout',
            subtitle: 'Priority Late*',
            activeTiers: ['Silver'],
          },
          {
            title: '2 p.m. Late Checkout',
            subtitle: 'Up to 2 p.m.*',
            activeTiers: ['Gold'],
          },
        ],
        order: 6,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'welcome_gift',
        icon: 'gift',
        title: 'Welcome Gift',
        fullText: 'Receive a special gift upon arrival at participating hotels. Gifts vary by brand and region.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Pionts',
            subtitle: 'Pionts',
            activeTiers: ['Gold'],
          },
          {
            title: 'Points, Breakfast Offering, or Amenity',
            subtitle: 'Points, Breakfast Offering, or Amenity',
            activeTiers: ['Platinum'],
          },
        ],
        order: 7,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'enhanced_room_upgrade',
        icon: 'all_suite_room',
        title: 'Enhanced Room Upgrade',
        fullText:
          'Enjoy a room upgrade for the entire length of your stay. For Platinum Elite members and above this includes select suites.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'Based on availability upon arrival at participating properties, for the entire length of stay.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Room Upgrade',
            subtitle: 'Room Upgrade',
            activeTiers: ['Gold'],
          },
          {
            title: 'Select Suites',
            subtitle: 'Select Suites',
            activeTiers: ['Platinum'],
          },
        ],
        order: 8,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'dedicated_elite_support',
        icon: 'service_request',
        title: 'Dedicated Elite Support',
        fullText: 'Receive 24/7 service for all your hotel booking needs.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 12,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'lounge_access',
        icon: 'lounge_access',
        title: 'Lounge Access',
        fullText: 'At hotel brands with lounges, full lounge access and complimentary breakfast based on availability.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 9,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'annual_choice_benefit',
        icon: 'gift',
        title: 'Annual Choice Benefit',
        fullText: 'Earn 50 and/or 75 Elite Night Credits to select an additional benefit.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://choice-benefit.marriott.com/en-us',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 10,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Titanium'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: '48_hour_guarantee',
        icon: '48_hour_guarantee',
        title: '48-Hour Guarantee',
        fullText: "Book by 3 p.m., 48 hours prior to arrival, and we'll always have a room available to you.",
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Titanium Elite members and above',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 11,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'your_24',
        icon: 'your_24',
        title: 'Your24™',
        fullText:
          'Choose your check-in time and keep your room until the same time on the day of departure. Request via Ambassador Service 2 days prior to arrival.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: 'Based on availability. Property and brand exceptions apply.',
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 2,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: null,
        icon: 'ambassador',
        title: 'Ambassador Service',
        fullText: 'Dedicated Personal Ambassador to assist you with all of your travel needs.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 1,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: null,
        customComponentKey: 'ambassador_plus_one',
        icon: 'ambassador_plus_one',
        title: 'Ambassador Plus One',
        fullText:
          'Gift Marriott Bonvoy Ambassador Elite status to a household member when you reach 100 nights and $40,000 USD in annual qualified spend.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_DETAILS_CTA_TEXT_MORE_DETAILS',
        ctaLink: 'https://plusone.marriott.com/',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 4,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'emirates_skywards',
        icon: 'airport',
        title: 'Emirates Skywards',
        fullText:
          'Earn miles on stays and points on flights, plus Platinum Elite members and above can enjoy priority check-in and boarding with Emirates.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://your-world-rewards.marriott.com/',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Earn Miles + Points',
            subtitle: 'Earn Miles + Points',
            activeTiers: ['Gold'],
          },
          {
            title: 'Priority Check-In and Boarding',
            subtitle: 'Priority Check-In and Boarding',
            activeTiers: ['Platinum'],
          },
        ],
        order: 13,
      },
      {
        _variation: 'master',
        activeTiers: null,
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'hertz_gold_plus_rewards',
        icon: 'car_rental',
        title: 'Hertz Gold Plus Rewards®',
        fullText: 'Get the status you deserve with complimentary Hertz Gold Plus Rewards® elite status.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://mrhertzstatus.com/MemberStat',
        benefitDisclaimer: 'Available to members in US and Canada',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Hertz Gold Plus Rewards®',
        benefitCode: null,
        modalTable: [
          {
            title: 'Hertz Fast Track to Five Star®',
            subtitle: 'Fast Track to Five Star®',
            activeTiers: ['Platinum'],
          },
          {
            title: 'Hertz Five Star®',
            subtitle: 'Five Star®',
            activeTiers: ['Titanium'],
          },
          {
            title: 'Hertz President’s Circle®',
            subtitle: 'President’s Circle®',
            activeTiers: ['Ambassador'],
          },
        ],
        order: 23,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Titanium'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'united_mileage_plus',
        icon: 'airport',
        title: 'United MileagePlus®',
        fullText:
          'Receive enhanced benefits and Premier® Silver status through our partnership with United MileagePlus®.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://travel-partner.marriott.com/united/en-us',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Titanium Elite members and above',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 14,
      },
    ],
  },
  {
    tier: 'Titanium',
    tierTag: ['mcom-common-spa:mobile/member-tiers/titanium'],
    benefits: [
      {
        _variation: 'master',
        activeTiers: ['Titanium', 'Ambassador'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'bonus_points',
        icon: 'more_points_on_stays',
        title: '75% Bonus Points',
        fullText: 'Earn bonus points on eligible hotel purchases.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'To be eligible, you must provide your member number when making a reservation. Compensation varies by hotel brand.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: '75% Bonus Points',
        benefitCode: null,
        modalTable: [
          {
            title: '10% Bonus Points',
            subtitle: '10% Bonus Points',
            activeTiers: ['Silver'],
          },
          {
            title: '25% Bonus Points',
            subtitle: '25% Bonus Points',
            activeTiers: ['Gold'],
          },
          {
            title: '50% Bonus Points',
            subtitle: '50% Bonus Points',
            activeTiers: ['Platinum'],
          },
        ],
        order: 3,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'enhanced_room_upgrade',
        icon: 'all_suite_room',
        title: 'Enhanced Room Upgrade',
        fullText:
          'Enjoy a room upgrade for the entire length of your stay. For Platinum Elite members and above this includes select suites.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer:
          'Based on availability upon arrival at participating properties, for the entire length of stay.',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Room Upgrade',
            subtitle: 'Room Upgrade',
            activeTiers: ['Gold'],
          },
          {
            title: 'Select Suites',
            subtitle: 'Select Suites',
            activeTiers: ['Platinum'],
          },
        ],
        order: 8,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'welcome_gift',
        icon: 'gift',
        title: 'Welcome Gift',
        fullText: 'Receive a special gift upon arrival at participating hotels. Gifts vary by brand and region.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Pionts',
            subtitle: 'Pionts',
            activeTiers: ['Gold'],
          },
          {
            title: 'Points, Breakfast Offering, or Amenity',
            subtitle: 'Points, Breakfast Offering, or Amenity',
            activeTiers: ['Platinum'],
          },
        ],
        order: 7,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Titanium'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: '48_hour_guarantee',
        icon: '48_hour_guarantee',
        title: '48-Hour Guarantee',
        fullText: "Book by 3 p.m., 48 hours prior to arrival, and we'll always have a room available to you.",
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Titanium Elite members and above',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 11,
      },
      {
        _variation: 'master',
        activeTiers: ['Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'hertz_gold_plus_rewards',
        icon: 'car_rental',
        title: 'Hertz Five Star®',
        fullText: 'Get the status you deserve with complimentary Hertz Gold Plus Rewards® elite status.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://mrhertzstatus.com/MemberStat',
        benefitDisclaimer: 'Available to members in US and Canada',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Five Star®',
        benefitCode: null,
        modalTable: [
          {
            title: 'Hertz Fast Track to Five Star®',
            subtitle: 'Fast Track to Five Star®',
            activeTiers: ['Platinum'],
          },
          {
            title: 'Hertz President’s Circle®',
            subtitle: 'President’s Circle®',
            activeTiers: ['Ambassador'],
          },
        ],
        order: 20,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Basic', 'Gold', 'Platinum', 'Silver', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: null,
        customComponentKey: 'sixt_status_match',
        icon: 'car_rental',
        title: 'SIXT Status Match',
        fullText:
          'From your car rental to your hotel reservation, stay on the same level. Enjoy the benefits of matching your status with Marriott Bonvoy® and SIXT. Each offers their own great benefits, making your journey more premium.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_DETAILS_CTA_TEXT_MORE_DETAILS',
        ctaLink: 'https://www.sixt.com/services/#/b2bregistration?b2b_token=4b11c5e4-4394-0597-5e8a-02c2763f5d00',
        benefitDisclaimer: 'Available to members outside the US and Canada',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: true,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'SIXT Express Card',
            subtitle: 'SIXT Express Card',
            activeTiers: ['Silver'],
          },
          {
            title: 'SIXT Gold Card',
            subtitle: 'SIXT Gold Card',
            activeTiers: ['Gold', 'Platinum'],
          },
          {
            title: 'SIXT Diamond Card',
            subtitle: 'SIXT Diamond Card',
            activeTiers: ['Ambassador', 'Titanium'],
          },
        ],
        order: 6,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Titanium'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'united_mileage_plus',
        icon: 'airport',
        title: 'United MileagePlus®',
        fullText:
          'Receive enhanced benefits and Premier® Silver status through our partnership with United MileagePlus®.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://travel-partner.marriott.com/united/en-us',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Titanium Elite members and above',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 14,
      },
      {
        _variation: 'master',
        activeTiers: ['Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'ultimate_reservation_guarantee',
        icon: 'ultimate_reservation_guarantee',
        title: 'Ultimate Reservation Guarantee',
        fullText:
          'If we can’t honor your reservation, we’ll pay for you to stay nearby and compensate you for the inconvenience.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi ',
        benefitAlert: 'Silver Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 5,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'late_checkout',
        icon: 'late_check_out',
        title: '4 p.m. Late Checkout',
        fullText: 'Request Late Checkout and spend more time exploring the sites or relaxing. Exceptions apply.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: '*Based on availability',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'Late Checkout',
        benefitCode: null,
        modalTable: [
          {
            title: 'Priority Late Checkout',
            subtitle: 'Priority Late*',
            activeTiers: ['Silver'],
          },
          {
            title: '2 p.m. Late Checkout',
            subtitle: 'Up to 2 p.m.*',
            activeTiers: ['Gold'],
          },
        ],
        order: 6,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'dedicated_elite_support',
        icon: 'service_request',
        title: 'Dedicated Elite Support',
        fullText: 'Receive 24/7 service for all your hotel booking needs.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 12,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'lounge_access',
        icon: 'lounge_access',
        title: 'Lounge Access',
        fullText: 'At hotel brands with lounges, full lounge access and complimentary breakfast based on availability.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/member-benefits/guarantee.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 9,
      },
      {
        _variation: 'master',
        activeTiers: ['Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'annual_choice_benefit',
        icon: 'gift',
        title: 'Annual Choice Benefit',
        fullText: 'Earn 50 and/or 75 Elite Night Credits to select an additional benefit.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://choice-benefit.marriott.com/en-us',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Platinum Elite members and above',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 10,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador', 'Gold', 'Platinum', 'Titanium'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'emirates_skywards',
        icon: 'airport',
        title: 'Emirates Skywards',
        fullText:
          'Earn miles on stays and points on flights, plus Platinum Elite members and above can enjoy priority check-in and boarding with Emirates.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://your-world-rewards.marriott.com/',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [
          {
            title: 'Earn Miles + Points',
            subtitle: 'Earn Miles + Points',
            activeTiers: ['Gold'],
          },
          {
            title: 'Priority Check-In and Boarding',
            subtitle: 'Priority Check-In and Boarding',
            activeTiers: ['Platinum'],
          },
        ],
        order: 13,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'exclusive_member_rates',
        icon: 'member_rates',
        title: 'Exclusive Member Rates',
        fullText: 'Enjoy exclusive discounted rates for Marriott Bonvoy Members.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 16,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'complimentary_wifi',
        icon: 'wifi',
        title: 'Complimentary Wi-Fi',
        fullText: 'Stay connected. Members enjoy complimentary Wi-Fi.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 15,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'instant_redemption',
        icon: 'gift_points',
        title: 'Instant Redemption',
        fullText:
          'During your stay at any of our participating hotels, instantly redeem points for cocktails, meals, spa experiences and more — anything you can charge to your hotel room.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/redeem.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 17,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'cash_points',
        icon: 'cash_and_points',
        title: 'Cash + Points',
        fullText:
          'Book and pay for your room by combining cash and points — stay for as little as $55 and 3,500 points.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_CTACOPY_MORE_DETAILS',
        ctaLink: 'https://www.marriott.com/loyalty/redeem/hotels/cash-points.mi',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 18,
      },
      {
        _variation: 'master',
        activeTiers: ['Basic', 'Silver', 'Gold', 'Platinum', 'Titanium', 'Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'mobile_checkin',
        icon: 'keyless_entry',
        title: 'Mobile Check-in & Mobile Key',
        fullText: 'Use our app to check in and out, then use your phone as your room key.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: null,
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 19,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'your_24',
        icon: 'your_24',
        title: 'Your24™',
        fullText:
          'Choose your check-in time and keep your room until the same time on the day of departure. Request via Ambassador Service 2 days prior to arrival.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: 'Based on availability. Property and brand exceptions apply.',
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 2,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: 'No',
        customComponentKey: 'ambassador_service',
        icon: 'ambassador',
        title: 'Ambassador Service',
        fullText: 'Dedicated Personal Ambassador to assist you with all of your travel needs.',
        ctaCopy: null,
        ctaKey: null,
        ctaLink: null,
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: null,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 1,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Plain',
        hasCustomContent: null,
        customComponentKey: 'ambassador_plus_one',
        icon: 'ambassador_plus_one',
        title: 'Ambassador Plus One',
        fullText:
          'Gift Marriott Bonvoy Ambassador Elite status to a household member when you reach 100 nights and $40,000 USD in annual qualified spend.',
        ctaCopy: 'More Details',
        ctaKey: 'BENEFITS_DETAILS_CTA_TEXT_MORE_DETAILS',
        ctaLink: 'https://plusone.marriott.com/',
        benefitDisclaimer: null,
        webCtaLink: null,
        benefitAlert: 'Ambassador Elite members',
        isPartner: false,
        subtitle: null,
        benefitCode: null,
        modalTable: [],
        order: 4,
      },
      {
        _variation: 'master',
        activeTiers: ['Ambassador'],
        modalType: 'Table',
        hasCustomContent: 'No',
        customComponentKey: 'hertz_gold_plus_rewards',
        icon: 'car_rental',
        title: 'Hertz President’s Circle®',
        fullText: 'Get the status you deserve with complimentary Hertz Gold Plus Rewards® elite status.',
        ctaCopy: 'Link Your Account',
        ctaKey: 'BENEFITS_CTACOPY_LINK_ACCOUNT',
        ctaLink: 'https://mrhertzstatus.com/MemberStat',
        benefitDisclaimer: 'Available to members in US and Canada',
        webCtaLink: null,
        benefitAlert: null,
        isPartner: false,
        subtitle: 'President’s Circle®',
        benefitCode: null,
        modalTable: [
          {
            title: 'Hertz Fast Track to Five Star®',
            subtitle: 'Fast Track to Five Star®',
            activeTiers: ['Platinum'],
          },
          {
            title: 'Hertz Five Star®',
            subtitle: 'Five Star®',
            activeTiers: ['Titanium'],
          },
        ],
        order: 4,
      },
    ],
  },
];
